import React from "react";
import { useTranslation } from "react-i18next";
import { ApiInternal } from "src/api/api_internal";
import { UUID } from "src/api/api_common";
import { ConfirmDialog } from "src/components/base/confirm-dialog";

/**
 * The properties for {@link DisableSubnetDialog}
 */
export type DisableSubnetDialogProps = {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful disable */
    onDisable: () => void;
    /** The subnet */
    subnet:
        | {
              /** Name of the subnet */
              name: string;
              /** UUID of the subnet */
              uuid: UUID;
          }
        | undefined;
};

/**
 * Dialog to disable a given subnet
 */
export default function DisableSubnetDialog(props: DisableSubnetDialogProps) {
    const [t] = useTranslation("dialog-disable-subnet");

    if (!props.subnet) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.subnet) return;
                await ApiInternal.subnets.disable(props.subnet.uuid);
                props.onDisable();
            }}
            title={t("heading.disable-subnet", { subnet: props.subnet.name })}
            description={t("description.disable-subnet")}
            confirmLabel={t("button.disable-subnet")}
        />
    );
}
